import React from 'react';
import { BulkHoldingsProxyPicker, type FundToProxy } from '../../modals';
import SidePanelOverlay from '../../side-panel-overlay/SidePanelOverlay';
import type { ProxyMetaWithName } from '../../modals/pickers/proxy-picker/BulkProxyPicker';
import { BulkProxyPicker as BulkReturnsProxyPicker } from '../../modals/pickers/proxy-picker/BulkProxyPicker';
import type { BulkManagementTableModalManager } from '../types';
import type { FundToBulkProxy } from '../../modals/pickers/types';
import { Match } from 'effect';
import { isNil } from 'lodash';

type ProxyPickerSidePanelProps = {
  handleClose: () => void;
  onProxyChange:
    | ((appliedProxies: ProxyMetaWithName[], failedToProxyFunds: (FundToProxy | FundToBulkProxy)[]) => void)
    | undefined;
  investments: (FundToProxy | FundToBulkProxy)[];
  activeModal: BulkManagementTableModalManager['activeModal'];
};
export const ProxyPickerSidePanel = ({
  handleClose,
  activeModal,
  investments,
  onProxyChange,
}: ProxyPickerSidePanelProps) => (
  <SidePanelOverlay.Root
    width={1062}
    margin={0}
    noPadding
    side="right"
    isOpen={!isNil(activeModal)}
    handleClose={handleClose}
    useFocusTrap={false}
    hideTopBackButton
  >
    {Match.value(activeModal).pipe(
      Match.when('returnsProxy', () => (
        <BulkReturnsProxyPicker investments={investments} onProxyChange={onProxyChange} />
      )),
      Match.when('holdingsProxy', () => (
        <BulkHoldingsProxyPicker investments={investments} onProxyChange={onProxyChange} />
      )),
      Match.when(null, () => null),
      Match.exhaustive,
    )}
  </SidePanelOverlay.Root>
);
